import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_NOMENCLAT_SCHEMA_LITERAL = {
    title: 'Schéma Nomenclatures',
    description: 'Décrit les Nomenclatures',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        NO_REFDET: { type: 'string' },
        NO_QTE: { type: 'number' },
        AG_NO1: { type: 'number' },
        AG_NO1LIB: { type: 'string' },
        AG_NO2: { type: 'number' },
        AG_NO2LIB: { type: 'string' },
        NO_TYPE: { type: 'number' },
        NO_REPARTITION: { type: 'number' },
        NO_OPERATION: { type: 'string' },
        NO_ORDRE: { type: 'number' },
        AG_NO1COMP: { type: 'number' },
        AG_NO2COMP: { type: 'number' },
        NO_SOUSTRAITANCE: { type: 'number' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'NO_REFDET', 'NO_QTE' ]  
} as const;

const schemaTyped = toTypedRxJsonSchema(F_NOMENCLAT_SCHEMA_LITERAL);
export type RxFNomenclatDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_NOMENCLAT_SCHEMA: RxJsonSchema<RxFNomenclatDocumentType> = F_NOMENCLAT_SCHEMA_LITERAL;
